/* MRPIECE — product motion videos. Loads nothing until needed. */
(function(){
  if (window.__mwMotion) return; window.__mwMotion = true;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  function load(v){ if (v.dataset.src){ v.src = v.dataset.src; v.removeAttribute('data-src'); } }
  function play(card){
    var v = card.querySelector('.mw-card__vid'); if (!v || reduce) return;
    load(v); var p = v.play(); card.classList.add('is-playing');
    if (p && p.catch) p.catch(function(){ card.classList.remove('is-playing'); });
  }
  function stop(card){
    var v = card.querySelector('.mw-card__vid'); if (!v) return;
    v.pause(); card.classList.remove('is-playing');
  }
  function bind(root){
    (root || document).querySelectorAll('.mw-card[data-motion]:not([data-motion-bound])').forEach(function(card){
      card.setAttribute('data-motion-bound','');
      if (canHover){
        card.addEventListener('mouseenter', function(){ play(card); });
        card.addEventListener('mouseleave', function(){ stop(card); });
      } else if ('IntersectionObserver' in window){
        io.observe(card);
      }
    });
  }
  var current = null;
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting && e.intersectionRatio >= .7){
        if (current && current !== e.target) stop(current);
        current = e.target; play(e.target);
      } else if (e.target === current){ stop(e.target); current = null; }
    });
  }, { threshold: [0, .7] }) : null;
  function initPdp(){
    document.querySelectorAll('.mw-pdp-motion video[data-src]').forEach(function(v){
      if (reduce) return;
      if (!('IntersectionObserver' in window)){ load(v); v.play(); return; }
      var o = new IntersectionObserver(function(es){
        es.forEach(function(e){ if (e.isIntersecting){ load(v); v.play().catch(function(){}); } else { v.pause(); } });
      }, { threshold: .4 });
      o.observe(v);
    });
  }
  function init(){ bind(); initPdp(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  new MutationObserver(function(){ bind(); }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* MRPIECE — "This is a gift" in the cart drawer and on the cart page.
   Saved as cart attributes (Gift = Yes, Gift message = ...), shown on the order
   in Shopify admin under "Additional details". Injected by JS so the theme's
   cart sections stay untouched; re-inserted whenever the drawer re-renders. */
(function () {
  var state = { on: false, msg: '' }, loaded = false, t = null;
  var ICON = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>';
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function build() {
    var el = document.createElement('div');
    el.className = 'mw-gift';
    el.setAttribute('data-mw-gift', '');
    el.innerHTML =
      '<label class="mw-gift__row"><input type="checkbox" data-mw-gift-on><span class="mw-gift__box" aria-hidden="true"></span>' +
      '<span class="mw-gift__label">' + ICON + 'This is a gift</span></label>' +
      '<div class="mw-gift__more" data-mw-gift-more hidden>' +
      '<p class="mw-gift__note">No prices inside the box. Add a short message and we\'ll write it on a card.</p>' +
      '<textarea rows="2" maxlength="200" placeholder="Your message (optional)" aria-label="Gift message" data-mw-gift-msg></textarea>' +
      '<span class="mw-gift__saved" data-mw-gift-saved hidden>Saved</span></div>';
    paint(el);
    return el;
  }
  function paint(el) {
    el.querySelector('[data-mw-gift-on]').checked = state.on;
    el.querySelector('[data-mw-gift-more]').hidden = !state.on;
    var m = el.querySelector('[data-mw-gift-msg]');
    if (document.activeElement !== m) m.value = state.msg;
  }
  function place() {
    if (!loaded) return;
    var spots = [];
    document.querySelectorAll('.drawer__footer-buttons').forEach(function (f) { spots.push(f); });
    document.querySelectorAll('button[name="checkout"][form="cart"]').forEach(function (b) { spots.push(b.parentNode); });
    spots.forEach(function (spot) {
      var prev = spot.previousElementSibling;
      if (spot.classList.contains('drawer__footer-buttons')) {
        if (!spot.parentNode.querySelector(':scope > [data-mw-gift]')) spot.parentNode.insertBefore(build(), spot);
      } else if (!spot.querySelector('[data-mw-gift]')) {
        spot.insertBefore(build(), spot.firstChild);
      }
    });
  }
  function save(el) {
    fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: state.on ? { 'Gift': 'Yes', 'Gift message': state.msg } : { 'Gift': '', 'Gift message': '' } })
    }).then(function () {
      var s = el && el.querySelector('[data-mw-gift-saved]');
      if (s) { s.hidden = false; setTimeout(function () { s.hidden = true; }, 1200); }
    }).catch(function () {});
  }
  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-mw-gift-on]')) return;
    var el = e.target.closest('[data-mw-gift]');
    state.on = e.target.checked;
    if (!state.on) state.msg = '';
    document.querySelectorAll('[data-mw-gift]').forEach(paint);
    save(el);
    if (state.on) el.querySelector('[data-mw-gift-msg]').focus();
  });
  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-mw-gift-msg]')) return;
    var el = e.target.closest('[data-mw-gift]');
    state.msg = e.target.value;
    clearTimeout(t);
    t = setTimeout(function () { save(el); }, 600);
  });
  fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (c) {
      var a = (c && c.attributes) || {};
      state.on = a['Gift'] === 'Yes';
      state.msg = a['Gift message'] || '';
    })
    .catch(function () {})
    .then(function () { loaded = true; place(); });
  new MutationObserver(function () { place(); }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* MRPIECE — delivery note + free-delivery progress in the cart drawer and cart page.
   Fees match the shipping policy and Shopify delivery rates (read 9 Oct 2026):
   LE 100 Greater Cairo, LE 130 other governorates. Free delivery from LE 4,000
   comes from the automatic discount "Free delivery over LE 4,000" (created 9 Oct 2026).
   If either changes, change FREE and the text here too. */
(function () {
  var FREE = 400000; // in piasters (LE 4,000)
  var TRUCK = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 17V6a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v11h12Z"/><path d="M14 9h4l3 3v5h-7"/><circle cx="6" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>';
  var busy = false, again = false;
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function le(p) { return 'LE ' + Math.ceil(p / 100).toLocaleString('en-US'); }
  function build() {
    var el = document.createElement('div');
    el.className = 'mw-ship';
    el.setAttribute('data-mw-ship', '');
    el.innerHTML =
      '<p class="mw-ship__goal" data-mw-ship-goal>Free delivery on orders over LE 4,000</p>' +
      '<div class="mw-ship__bar" aria-hidden="true"><span data-mw-ship-fill></span></div>' +
      '<p class="mw-ship__fees">' + TRUCK + '<span>Otherwise LE 100 in Cairo, Giza &amp; Qalyubia · LE 130 other governorates. ' +
      'Pay cash when it arrives, after you check it. Free pickup from our New Cairo showroom.</span></p>';
    return el;
  }
  function paint(total) {
    var left = FREE - total, pct = Math.max(0, Math.min(100, total / FREE * 100));
    var msg = left > 0 ? le(left) + ' away from free delivery' : 'Free delivery on this order';
    document.querySelectorAll('[data-mw-ship]').forEach(function (el) {
      var g = el.querySelector('[data-mw-ship-goal]'), f = el.querySelector('[data-mw-ship-fill]');
      if (g.textContent !== msg) g.textContent = msg;
      var w = pct.toFixed(1) + '%';
      if (f.style.width !== w) f.style.width = w;
      el.classList.toggle('is-free', left <= 0);
    });
  }
  function refresh() {
    if (busy) { again = true; return; }
    busy = true;
    fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paint((c && c.total_price) || 0); })
      .catch(function () {})
      .then(function () { busy = false; if (again) { again = false; refresh(); } });
  }
  function place() {
    var added = false;
    document.querySelectorAll('.drawer__footer-buttons').forEach(function (spot) {
      if (!spot.parentNode.querySelector(':scope > [data-mw-ship]')) { spot.parentNode.insertBefore(build(), spot); added = true; }
    });
    document.querySelectorAll('button[name="checkout"][form="cart"]').forEach(function (b) {
      var spot = b.parentNode;
      if (!spot.querySelector('[data-mw-ship]')) { spot.insertBefore(build(), spot.firstChild); added = true; }
    });
    if (added) refresh();
  }
  var st = document.createElement('style');
  st.textContent =
    '.mw-ship{margin:0 0 12px;font-size:.78rem;line-height:1.4}' +
    '.mw-ship__goal{margin:0 0 6px;font-weight:600}' +
    '.mw-ship__bar{height:4px;border-radius:4px;background:rgb(var(--color-foreground) / .12);overflow:hidden;margin:0 0 8px}' +
    '.mw-ship__bar span{display:block;height:100%;width:0;background:currentColor;transition:width .4s}' +
    '.mw-ship.is-free .mw-ship__bar{display:none}' +
    '.mw-ship__fees{display:flex;gap:.5rem;align-items:flex-start;margin:0;opacity:.75}' +
    '.mw-ship__fees svg{flex:0 0 auto;margin-top:.1rem}';
  document.head.appendChild(st);
  place();
  new MutationObserver(function () { place(); }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('cart-items, .cart-drawer, form[action*="/cart"]')) setTimeout(refresh, 600);
  });
  // Refresh after any cart change made by the theme or an app (add, change, update, clear).
  if (window.fetch && !window.__mwShipFetch) {
    window.__mwShipFetch = true;
    var of = window.fetch;
    window.fetch = function (input) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function () { setTimeout(refresh, 150); }, function () {});
      }
      return p;
    };
  }
})();


/* MRPIECE — keep Add to cart near the top of the product page on mobile:
   move the Vitals "Buy more, save more" box from above the button to just below it. */
(function () {
  function move() {
    var box = document.querySelector('.vtl-ub-vd-widget');
    var buy = document.querySelector('.product-form-wrapper');
    if (!box || !buy || box.dataset.mwMoved) return;
    box.dataset.mwMoved = '1';
    buy.parentNode.insertBefore(box, buy.nextSibling);
  }
  move();
  new MutationObserver(move).observe(document.documentElement, { childList: true, subtree: true });
})();
